import { apiRoutes } from "../../../_config/apiRoutes";
import { apiSlice } from "../../../_api/apiSlice";

export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllUser: builder.query({
      query: (params) => ({
        url: apiRoutes.user.get.path,
        method: apiRoutes.user.get.reqType,
        params,
      }),
      providesTags: ["Users"],
    }),
    getUsersByOrgId: builder.query({
      query: (params) => ({
        url: `${apiRoutes.user.get.path}/getUsersByOrgId`,
        method: apiRoutes.user.get.reqType,
        params,
      }),
      providesTags: ["Users"],
    }),
    createUser: builder.mutation({
      query: (data) => ({
        url: apiRoutes.user.create.path,
        method: apiRoutes.user.create.reqType,
        body: data,
      }),
      invalidatesTags: ["Users"],
    }),
    getCurrentUser: builder.mutation({
      query: () => ({
        url: `${apiRoutes.user.get.path}/currentUser`,
        method: apiRoutes.user.get.reqType,
      }),
    }),
    editUser: builder.mutation({
      query: (data) => ({
        url: apiRoutes.user.edit.path,
        method: apiRoutes.user.edit.reqType,
        body: data,
      }),
      invalidatesTags: ["Users"],
    }),
    changeUserStatus: builder.mutation({
      query: (data) => ({
        url: `${apiRoutes.user.edit.path}/changeStatus`,
        method: apiRoutes.user.edit.reqType,
        body: data,
      }),
      invalidatesTags: ["Users"],
    }),
    editOnboardingOwner: builder.mutation({
      query: (data) => ({
        url: `${apiRoutes.user.editOnboardingOwner.path}/${data?.id}`,
        method: apiRoutes.user.editOnboardingOwner.reqType,
        body: data?.data,
      }),
    }),
    updateUserProfileImage: builder.mutation({
      query: (formData) => ({
        url: "uploads/profileImage",
        method: "POST",
        body: formData,
      }),
    }),
    deleteUserProfileImage: builder.mutation({
      query: () => ({
        url: "uploads/profileImage",
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useCreateUserMutation,
  useEditUserMutation,
  useChangeUserStatusMutation,
  useEditOnboardingOwnerMutation,
  useGetCurrentUserMutation,
  useGetAllUserQuery,
  useGetUsersByOrgIdQuery,
  useUpdateUserProfileImageMutation,
  useDeleteUserProfileImageMutation,
} = userApiSlice;
